import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'itemQuantity' })
export class ItemQuantityPipe implements PipeTransform {
  transform(itemQuantity: number) {
    return `${itemQuantity}x`;
  }
}
